import React from "react";
import { useTranslation } from "react-i18next";
import { useNurseOptionsGrouped } from "./hooks.mjs";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  RadioGroup,
} from "@mui/material";
import { errorsFromApi, FormErrorList } from "../../form";
import ConfirmationDialog from "../ConfirmationDialog";
import * as f from "../../utils/formatter";
import NurseGroup from "./NurseGroup";
import { employeeStatusToLabel, getAssignableRoles } from "./fn.mjs";
import * as api from "../../services/api";

function initialChangeAssignedEmployeeDialogState() {
  return {
    requestedValue: null,
    formId: crypto.randomUUID(),
    loading: false,
    errors: [],
  };
}

export default function ChangeAssignedEmployeeDialog({ appointments, close }) {
  const assignableRoles = React.useMemo(
    () => getAssignableRoles(appointments),
    [],
  );
  const [state, setState] = React.useState(
    initialChangeAssignedEmployeeDialogState(),
  );
  const { t } = useTranslation();
  const { options, flatOptions, loading } =
    useNurseOptionsGrouped(assignableRoles);

  return (
    <>
      <Dialog open={true} onClose={() => close()}>
        <DialogTitle>
          Změna personálu {f.fullName(appointments[0].employee)}
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <FormControl key={state.formId} required disabled={state.loading}>
              <RadioGroup
                onChange={async (_, value) => {
                  setState((state) => ({ ...state, requestedValue: value }));
                }}
              >
                <NurseGroup
                  label={employeeStatusToLabel.available}
                  nurses={options.available}
                />
                <NurseGroup
                  label={employeeStatusToLabel.assigned}
                  nurses={options.assigned}
                />
                <NurseGroup
                  label={employeeStatusToLabel.unavailable}
                  nurses={options.unavailable}
                />
              </RadioGroup>
            </FormControl>
          )}
          <FormErrorList formErrors={state.errors} />
        </DialogContent>
      </Dialog>
      {state.requestedValue != null && (
        <ConfirmationDialog
          title="Změna personálu"
          content={`Opravdu chcete změnit personál z ${f.fullName(appointments[0].employee)} na ${f.fullName(flatOptions.find((o) => o.id === state.requestedValue))}?`}
          onDecision={async (decision) => {
            if (decision) {
              setState((state) => ({ ...state, loading: true }));
              const result = await api.patchAppointments(
                appointments.map((appointment) => ({
                  id: appointment.id,
                  employee_id: state.requestedValue,
                })),
              );
              const errors = errorsFromApi({ result, t });
              setState((state) => ({ ...state, errors: errors }));
              if (errors.length === 0) {
                close();
              }
              setState((state) => ({ ...state, loading: false }));
            }

            setState((state) => ({ ...state, requestedValue: null }));
            if (!decision || state.errors.length > 0) {
              setState((state) => ({ ...state, formId: crypto.randomUUID() }));
            }
          }}
        />
      )}
    </>
  );
}
